const BARS = [
  "M15,26 L27,26 L18,48 L6,48 Z",
  "M33,17 L45,17 L36,48 L24,48 Z",
  "M51,8 L63,8 L54,48 L42,48 Z",
];

export function LogoMark({ className = "h-9 w-12", light = false }) {
  const mid = light ? "#F2EDE0" : "#132A4A";
  return (
    <svg viewBox="0 0 64 48" className={className} aria-hidden="true">
      <path d={BARS[0]} fill="#A9BFE0" />
      <path d={BARS[1]} fill={mid} />
      <path d={BARS[2]} fill="#E8394A" />
    </svg>
  );
}

export default function Logo({ light = false }) {
  return (
    <span className="flex items-center gap-3">
      <LogoMark light={light} className="h-9 w-12" />
      <span className="leading-none">
        <span
          data-testid="logo-wordmark"
          className={`font-display block text-lg font-black uppercase tracking-[0.14em] ${light ? "text-paper" : "text-obsidian"}`}
        >
          ON-ALL
        </span>
        <span className="font-mono mt-1 block text-[9px] font-bold tracking-[0.55em] text-[#E8394A]">
          LLC
        </span>
      </span>
    </span>
  );
}
